import ButtonDelete from "../ButtonDelete";
import Count from "../Count";
import "./style.scss";

import priceFormatter from "./../../utils/priceFormatter";

const CartProduct = ({ product }) => {
  const { img, title, count, priceTotal, id } = product;

  return ( 
    <section className="product">
      <div className="product__img">
        <img src={img} alt={title} />
      </div>
      <div className="product__title">{title}</div>
      <Count
        count={count} 
        id={id}
      />
      <div className="product__price">
        {priceFormatter.format(priceTotal)} руб.
      </div>
      <ButtonDelete id={id} />
    </section>
  );
};

export default CartProduct;
